import { createSelector } from 'reselect';

export const memberPortal = (state) => state.memberPortal;

export const ssnDetailsSelector = createSelector(
    [memberPortal],
    (memberPortal) => memberPortal.ssnDetails,
);
